"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const d3_1 = require("d3");
const d3_hypertree_1 = require("d3-hypertree");
const d3_hypertree_2 = require("d3-hypertree");
const d3_hypertree_3 = require("d3-hypertree");
const d3_hypertree_4 = require("d3-hypertree");
const demos_fs_1 = require("./demos-fs");
const d3_hypertree_5 = require("d3-hypertree");
const icons_1 = require("../icons/icons");
const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
const iconmap = new icons_1.Icons();
exports.alllanguages = ['sci', 'de', 'en', 'es', 'nl', 'ro', 'ru', 'zh'];
const isOtolNode = n => (n.parent && n.parent.data.name === treesource) ||
    (n.parent && n.parent.parent && n.parent.parent.data.name === treesource);
//const treesource = 'Wiki'
const treesource = 'Open-Tree-of-Life';
// files is typically the demo folder, without langmaps and folders, 
// this should be all tree example files.
function alldemos() {
    const released = [
        'sciuridae.d3.json',
        'primates.d3.json',
        'laurasiatheria.d3.json',
        'carnivora.d3.json',
        'metatheria.d3.json',
        'xenarthra.d3.json',
        'mammalia.d3.json',
        'hymenoptera.d3.json',
        'lophotrochozoa.d3.json',
        'chondrichthyes.d3.json'
    ];
    const blackexamples = [
        'sample.skos.xml',
        'sample.treeml.xml',
        'flare.d3.csv',
    ];
    demos_fs_1.files.children[1].name = treesource;
    d3_hypertree_5.dfs(demos_fs_1.files, n => {
        if (n.children)
            n.children = n.children.filter(c => !c.name.startsWith('_') &&
                !c.name.endsWith('.lang.json'));
    });
    // enable release    
    /*
    dfs(files, n=> {
        if (n.children && n.name === treesource)
            n.children = n.children.filter(c=> released.includes(c.name))
        if (n.children && n.name === 'Example-files')
            n.children = n.children.filter(c=> !blackexamples.includes(c.name))
    })*/
    const filesAsN = d3_1.hierarchy(demos_fs_1.files);
    const filteredfilesAsArray = filesAsN.descendants();
    //filteredfilesAsArray.forEach(n=> console.log(n.data.name, n.parent && n.parent.name))
    const treeFilesAsArray = filteredfilesAsArray.filter(n => n.data.type !== 'dir');
    treeFilesAsArray.forEach((e, i) => e.data.idx = i);
    treeFilesAsArray.forEach((n, i) => {
        if (isOtolNode(n)) {
            n.data.name = n.data.name.replace('\.d3\.json', '');
            if (n.name)
                n.name = n.name.replace('\.d3\.json', '');
        }
    });
    //console.log('danach:')
    //treeFilesAsArray.forEach(n=> console.log(n.data.name))
    // now its a array of tree examples files as N
    const pathesAsString = treeFilesAsArray.map((n /*:HierarchyNode<File>*/) => // get all demo-files with path
     n.ancestors()
        .map(n => n.data.name)
        .reverse());
    // now its a array of tree examples pathes as string[]
    const fileDemos = pathesAsString.map((demopath) => ({
        path: demopath.map(s => capitalize(s).replace('\.d3\.json', '')),
        loader: d3_hypertree_1.fromFile(demopath.join('/') +
            (demopath[1] === treesource
                ? '.d3.json'
                : '')),
        languages: demopath[1] === treesource
            ? exports.alllanguages
            : [],
        langloader: lang => (demopath[1] === treesource
            ? d3_hypertree_2.fromLangFile('langmaps/' + lang + '.lang.json')
            : ok => ok({})),
        nodeInit: (demopath[1] === treesource
            ? (ht, n) => {
                const id = n.data.name;
                n.precalc.imageHref = iconmap.fileName2IconUrl(id, n.data.type);
                n.precalc.icon = iconmap.emojimap[id];
                if (n.children)
                    if (n.height % 2 ||
                        (n.parent && n.parent.data.name === 'Bilateria') ||
                        n.data.name === 'Opisthokonta')
                        n.children = n.children.reverse();
                //shuffleArray(n.children, n)        
            }
            : (ht, n) => {
                const id = n.data.name;
                n.precalc.imageHref = iconmap.fileName2IconUrl(id, n.data.type);
                n.precalc.icon = iconmap.emojimap[id];
            }),
        hypertreeModel: demopath[2] === 'fs.d3.json'
            ? d3_hypertree_4.presets.fsModel()
            : ((demopath[2] === 'sample.skos.xml' || demopath[2] === 'flare.d3.csv')
                ? d3_hypertree_4.presets.acmflareModel()
                : ((demopath[2] === 'stackoverflow'
                    ? d3_hypertree_4.presets.stackoverflowModel()
                    : d3_hypertree_4.presets.otolModel())))
    }));
    const generatorDemos = Object.values(d3_hypertree_3.generators).map((generator, idx) => ({
        path: ['Generators', capitalize(generator.name)],
        loader: generator,
        languages: [],
        langloader: lang => ok => ok({}),
        nodeInit: (ht, n) => { },
        hypertreeModel: generator.name === 'spiral' // idx === 2 //
            ? d3_hypertree_4.presets.generatorSpiralModel()
            : d3_hypertree_4.presets.generatorModel()
    }));
    //console.log(generatorDemos.length, fileDemos.length)
    const stem = [{
            path: ['Entry', 'Hyperbolic Forest'],
            loader: ok => ok({
                name: 'Root',
                children: [
                    demos_fs_1.files.children[1],
                    {
                        name: 'Generators',
                        children: [
                            { name: 'Unitvectors', idx: fileDemos.length + 0 },
                            { name: 'Full Binary Tree', idx: fileDemos.length + 3 },
                            { name: 'Path', idx: fileDemos.length + 4 },
                        ]
                    },
                    demos_fs_1.files.children[0],
                ]
            }, performance.now()),
            languages: exports.alllanguages,
            langloader: lang => d3_hypertree_2.fromLangFile('langmaps/' + lang + '.lang.json'),
            nodeInit: (ht, n) => {
                const id = n.data.name;
                n.precalc.imageHref = iconmap.fileName2IconUrl(id, n.data.type);
                n.precalc.icon = iconmap.emojimap[id];
            },
            hypertreeModel: d3_hypertree_4.presets.mainModel()
        }];
    const result = fileDemos.concat(generatorDemos).concat(stem);
    return result;
}
exports.alldemos = alldemos;
class NavigationModel {
    constructor(languageCode = 'en', demoIdx = 0) {
        this.alldemos = alldemos();
        this.splitterProportion = [68, 32];
        const isMobile = window.matchMedia("only screen and (max-width: 30cm)").matches;
        if (isMobile)
            this.splitterProportion = [100, 0];
        this.currentdemoeIdx = (demoIdx + this.alldemos.length) % this.alldemos.length;
        this.currentdemo = this.alldemos[this.currentdemoeIdx];
        this.currentlang = languageCode;
        console.log('Navigation model created (set of hypertreee models)', this.alldemos);
    }
    next(Δ) {
        this.setidx(this.currentdemoeIdx + Δ + this.alldemos.length);
    }
    last() {
        this.setidx(this.alldemos.length - 1);
    }
    islast() {
        return this.currentdemoeIdx === this.alldemos.length - 1;
    }
    setidx(idx) {
        this.currentdemoeIdx = idx;
        this.currentdemo = this.alldemos[this.currentdemoeIdx % this.alldemos.length];
        console.assert(this.currentdemo);
        console.log('Navigation setidx', idx, this.currentdemo);
    }
}
exports.NavigationModel = NavigationModel;
class OtolSetModel {
    constructor() {
        this.fileExistsTable = {};
    }
    OtolSetModel() {
        console.log("ALL FILES", demos_fs_1.files);
        /*
        dfs(files, n=> {
            console.log(n.name, cladename+".d3.json")
            if (n.name.toLowerCase() === (cladename+".d3.json").toLowerCase())
                fileExistsTable[e]  = true
        })
        */
    }
    fileExists(cladename) {
        let e = false;
        d3_hypertree_5.dfs(demos_fs_1.files, n => {
            if (n.name.toLowerCase() === (cladename + ".d3.json").toLowerCase())
                e = true;
        });
        return e;
    }
}
exports.OtolSetModel = OtolSetModel;



//////////////////
// WEBPACK FOOTER
// ./dist/js/models/navigation/model.js
// module id = 231
// module chunks = 0